import { List, Map, fromJS } from 'immutable';
import { uid } from '../../../utils/random';
import { clone } from 'lodash';

export function request(state, { userId, bet }) {
    let splitBetUid = uid();

    bet = {
        ...bet,
        stakePerLine: Math.round((bet.stakePerLine / 2) * 100) / 100,
        isSplitted: true,
        splittedTo: splitBetUid
    };

    let userBets = state.getIn([ 'bets', userId ]);
    let betIndex = userBets.findIndex( x => x.get('uid') === bet.uid);

    state = state.setIn([ 'bets', userId, betIndex ], fromJS(bet));

    let splittedBet = {
        ...bet,
        uid: splitBetUid,
        splittedFrom: bet.uid
    };

    splittedBet.legs.forEach((legId, i) => {
        let newLegUid = uid();

        let oldLeg = state.getIn([ 'legs', userId, legId ]) || Map();
        oldLeg = oldLeg
            .set('isSplitted', true)
            .set('uid', newLegUid);
        state = state.setIn([ 'legs', userId, newLegUid ], oldLeg);

        splittedBet.legs[i] = newLegUid;
    });

    state = state.set(
        'bets',
        state.get('bets').set(
            userId,
            (state.getIn([ 'bets', userId ]) || List()).push(fromJS(splittedBet))
        )
    );

    return state;
}
